import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-10a097ca"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "wrapper-container"
};
var _hoisted_2 = {
  class: "inner-container"
};

var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "title"
  }, "关于我们", -1);
});

var _hoisted_4 = {
  class: "desc-list"
};

var _hoisted_5 = /*#__PURE__*/_createTextVNode("活动介绍");

var _hoisted_6 = {
  key: 0
};

var _hoisted_7 = /*#__PURE__*/_createTextVNode("活动问答");

var _hoisted_8 = /*#__PURE__*/_createTextVNode("优秀作品");

var _hoisted_9 = /*#__PURE__*/_createTextVNode("活动资讯");

var _hoisted_10 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "title"
  }, "编程教学", -1);
});

var _hoisted_11 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("ul", {
    class: "desc-list"
  }, [/*#__PURE__*/_createElementVNode("li", null, [/*#__PURE__*/_createElementVNode("a", {
    class: "hover-link",
    href: "https://hetao101.com/"
  }, "核桃编程")]), /*#__PURE__*/_createElementVNode("li", null, [/*#__PURE__*/_createElementVNode("a", {
    class: "hover-link",
    href: "https://d.hetao101.com/"
  }, "下载中心")])], -1);
});

var _hoisted_12 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "title"
  }, "联系我们", -1);
});

var _hoisted_13 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("ul", {
    class: "desc-list"
  }, [/*#__PURE__*/_createElementVNode("li", null, "北京市海淀区苏州街银科大厦11层"), /*#__PURE__*/_createElementVNode("li", null, "邮箱地址：saishihuodong@hetao101.com")], -1);
});

var _hoisted_14 = {
  class: "friend-link-list"
};

var _hoisted_15 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: ""
  }, "友情链接：", -1);
});

var _hoisted_16 = /*#__PURE__*/_createTextVNode("全国青少年软件编程等级考试");

var _hoisted_17 = /*#__PURE__*/_createTextVNode("蓝桥杯大赛");

var _hoisted_18 = /*#__PURE__*/_createTextVNode("全国中小学生信息与实践创新大赛");

var _hoisted_19 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("h3", {
    class: "title"
  }, "关注我们", -1);
});

var _hoisted_20 = ["src"];

var _hoisted_21 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "qrcode-desc"
  }, "公众号二维码", -1);
});

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_router_link = _resolveComponent("router-link");

  var _component_a_col = _resolveComponent("a-col");

  var _component_a_row = _resolveComponent("a-row");

  var _component_a_button = _resolveComponent("a-button");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_a_row, {
    type: "flex"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_a_col, {
        flex: "auto"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_a_row, null, {
            default: _withCtx(function () {
              return [_createVNode(_component_a_col, {
                span: 6
              }, {
                default: _withCtx(function () {
                  return [_hoisted_3, _createElementVNode("ul", _hoisted_4, [_createElementVNode("li", null, [_createVNode(_component_router_link, {
                    class: "hover-link",
                    to: "/why-learn-program"
                  }, {
                    default: _withCtx(function () {
                      return [_hoisted_5];
                    }),
                    _: 1
                  })]), false ? (_openBlock(), _createElementBlock("li", _hoisted_6, [_createVNode(_component_router_link, {
                    class: "hover-link",
                    to: "/item/faq"
                  }, {
                    default: _withCtx(function () {
                      return [_hoisted_7];
                    }),
                    _: 1
                  })])) : _createCommentVNode("", true), _createElementVNode("li", null, [_createVNode(_component_router_link, {
                    class: "hover-link",
                    to: "/excellent"
                  }, {
                    default: _withCtx(function () {
                      return [_hoisted_8];
                    }),
                    _: 1
                  })]), _createElementVNode("li", null, [_createVNode(_component_router_link, {
                    class: "hover-link",
                    to: "/item/info"
                  }, {
                    default: _withCtx(function () {
                      return [_hoisted_9];
                    }),
                    _: 1
                  })])])];
                }),
                _: 1
              }), false ? (_openBlock(), _createBlock(_component_a_col, {
                key: 0,
                span: 6
              }, {
                default: _withCtx(function () {
                  return [_hoisted_10, _hoisted_11];
                }),
                _: 1
              })) : _createCommentVNode("", true), _createVNode(_component_a_col, {
                span: 6
              }, {
                default: _withCtx(function () {
                  return [_hoisted_12, _hoisted_13];
                }),
                _: 1
              })];
            }),
            _: 1
          }), _createVNode(_component_a_row, null, {
            default: _withCtx(function () {
              return [_createVNode(_component_a_col, null, {
                default: _withCtx(function () {
                  return [_createElementVNode("div", _hoisted_14, [_hoisted_15, _createVNode(_component_a_button, {
                    class: "friend-link hover-link",
                    type: "link",
                    href: "https://www.qceit.org.cn/bos/default.html"
                  }, {
                    default: _withCtx(function () {
                      return [_hoisted_16];
                    }),
                    _: 1
                  }), _createVNode(_component_a_button, {
                    class: "friend-link hover-link",
                    type: "link",
                    href: "http://kid.lanqiao.cn/"
                  }, {
                    default: _withCtx(function () {
                      return [_hoisted_17];
                    }),
                    _: 1
                  }), _createVNode(_component_a_button, {
                    class: "friend-link hover-link",
                    type: "link",
                    href: "http://s.noc.net.cn/"
                  }, {
                    default: _withCtx(function () {
                      return [_hoisted_18];
                    }),
                    _: 1
                  })])];
                }),
                _: 1
              })];
            }),
            _: 1
          })];
        }),
        _: 1
      }), false ? (_openBlock(), _createBlock(_component_a_col, {
        key: 0,
        flex: "200px"
      }, {
        default: _withCtx(function () {
          return [_hoisted_19, _createVNode(_component_a_row, {
            gutter: 24
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_a_col, {
                span: 12
              }, {
                default: _withCtx(function () {
                  return [_createElementVNode("img", {
                    width: 88,
                    height: 88,
                    src: _ctx.Qrcode1,
                    alt: "二维码"
                  }, null, 8, _hoisted_20), _hoisted_21];
                }),
                _: 1
              })];
            }),
            _: 1
          })];
        }),
        _: 1
      })) : _createCommentVNode("", true)];
    }),
    _: 1
  })])]);
}